import BaseModelFactory from './base.factory'
import SystemSettingService from './../services/SystemSetting.service'
import SystemSetting from './../models/system-setting.model'

class SystemSettingFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: SystemSettingService, Model: SystemSetting }
    )
  static findById = async id =>
    await this._findBy({ site_id: id }, { Service: SystemSettingService, Model: SystemSetting })
  static findByKey = async key =>
    await this._findBy({ setting_key: key }, { Service: SystemSettingService, Model: SystemSetting })
}

export default SystemSettingFactory
